import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import btnClose from '../../assets/svg/btn/close.svg';
import axiosClient from '../../../axios-client';
import { ToastContainer, toast } from 'react-toastify';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';

const AskForTemplate = ({ show, handleClose}) => {
    const [caseMsg, setCase] = useState('');
    const [exampleMsg, setMessage] = useState('');

    const successNotify = ({ msgErr }) => {
        toast.success(`${msgErr}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    };

    const errNotify = ({ msgErr }) => {
        toast.error(`${msgErr}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const payload = {
            use_case: caseMsg,
            example: exampleMsg,
        };

        try {
            const response = await axiosClient.post('/template/templates-request', payload);
            successNotify({ msgErr: response.data.message });
            handleClose();
            setCase('');
            setMessage('');
        } catch (error) {
            errNotify({ msgErr: error.response?.data?.message || 'An error occurred' });
        }
    };

    const placeholderText = `Hi {clientname},
This is to inform you that your request regarding {therequesttitle} is now {status}.
Best regards,
{companyname}.`;

    return (
        <Modal centered className="modal-lg" show={show} onHide={handleClose}>
            <ToastContainer />
            <Modal.Header className="border-0 d-flex flex-row-reverse bd-highlight">
                <Button className="rounded-circle btn-gray" variant="none" onClick={handleClose}>
                    <img src={btnClose} alt="Close" />
                </Button>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid text-center">
                    <h2 className="text-center title mt-0 mb-4">Ask for a new Template</h2>
                </div>
                <form onSubmit={ handleSubmit } className="row my-0 mx-4 justify-content-center align-items-center">
                    <div className="form-group mb-2">
                            <label htmlFor="exampleMessage">What is your request?</label>
                    </div>
                    <textarea
                        required
                        value={caseMsg}
                        onChange={(e) => setCase(e.target.value)}
                        className="form-control col-md-5 rounded-25"
                        placeholder="Explain the use case..."
                        rows="4"
                    />
                    
                    <div className="form-group mt-4 mb-1">
                    <label htmlFor="">Please ensure to fill in the dynamic <OverlayTrigger  placement="top" overlay={<Tooltip id="tooltip-info">Please ensure to fill in the dynamic fields with the appropriate details, such as the client's name, request title, status, and company name, which are specific to your request.</Tooltip>}>
                        <InfoIcon className="m-1 ms-auto" />
                    </OverlayTrigger></label>
                    </div>
                    <textarea
                        required
                        value={exampleMsg}
                        onChange={(e) => setMessage(e.target.value)}
                        className="form-control col-md-5 rounded-25"
                        placeholder={placeholderText}
                        rows="6"
                    />
                    <input
                        type="submit"
                        className="mx-auto col-md-3 text-center mt-3 btn-primary mb-3"
                        value="Send Request"
                    />
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default AskForTemplate;
